import React from 'react';

interface OwnProps {
  /** Tooltip text. Also used as the accessible label if `aria-label` is not provided. */
  title: string;
  ariaLabel?: string;
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Icon button used in the editor toolbar (Undo, Redo, Cut, Copy, Paste...).
 *
 * Styling lives in `styles.css` under `.editor-toolbar button.tool-icon`.
 */
const ToolIcon = ({ title, ariaLabel, children, onClick }: OwnProps) => (
  <button
    type='button'
    onClick={onClick}
    className='tool-icon'
    title={title}
    aria-label={ariaLabel ?? title}
  >
    {children}
  </button>
);

const MemoToolIcon = React.memo(ToolIcon);

export { MemoToolIcon as ToolIcon };
export default MemoToolIcon;
